module.exports = __webpack_public_path__ + "static/media/login-img.976b0660.png";